import { useEffect, useRef, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import { toast } from "react-toastify";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useDispatch, useSelector } from "react-redux";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import EditIcon from "../../../components/Icons/EditIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import {
  saveActiveStockOutTab,
  updateFiltersStates,
} from "../../../store/actions/UserActions";
import ExportDataHandler from "../../../utility/ExportDataHandler";

export default function StockOut() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const ActiveTab = useSelector((state) => state?.root?.activeStockOutTab);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    filterData: "",
    month: "",
    StockList: [],
    searchQuery: "",
    siteList: [],
    status: ActiveTab,
    siteId: filterDetails?.siteId,
    companyList: [],
    canStockOut: false,
 companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
  });

  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const [modal, setModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const timeoutId = useRef(null);

  const toggleModal = () => {
    setModal(!modal);
  };

  useEffect(() => {
    if (filterDetails?.year) {
      GetStockOutList(filterDetails?.currentPage);
    }
  }, [
    filterDetails?.currentPage,
    ActiveTab,
    pageStates.searchQuery,
    filterDetails?.sortByDate,
    filterDetails?.year,
    filterDetails.pageSize,
    filterDetails?.siteId,
    pageStates?.status,
    filterDetails?.companyId,
    filterDetails?.orderBy,
    pageStates?.isInitial,
  ]);

  useEffect(() => {
    GetSiteList(filterDetails?.companyId);
  }, [filterDetails?.companyId]);

  useEffect(() => {
    GetCompanyList();
  }, []);

  const GetStockOutList = (pageNo) => {
    let options = {
      method: "GET",
    };
    const filterData = {
      status: pageStates?.status,
      searchQuery: pageStates.searchQuery,
      siteId: pageStates?.siteId,
      ...filterDetails,
    };
    const Url = apiUrl.get_stock_out + MainFilterHandler(filterData);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.stockOut?.map((item) => ({
          ...item,
          siteName: item?.site?.name,
          grnDate: moment(item?.date).format("DD-MM-YYYY"),
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
        }));
        setPageStates((pre) => ({
          ...pre,
          StockList: newData,
          canStockOut: res?.data?.canStockOut
        }));
        dispatch(
          updateFiltersStates({
            count: res?.data?.pageInfo?.total,
            totalPages: res?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${
        inputValue ? `?search=${inputValue}` : ""
      }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const toggleTab = (tab) => {
    dispatch(saveActiveStockOutTab(tab));
    setPageStates((prev) => ({
      ...prev,
      status: tab,
    }));
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        companyId: "",
        pageSize: 10,
      })
    );
    if (pageStates?.siteList?.length == 0) {
      GetSiteList();
    }
  };

  const TableHeadingAgainstPo = [
    { value: "stockOutNumber", label: "Stock Out Number" },
    { value: "siteName", label: "Site Name" },
    { value: "grnDate", label: "Date" },
    { value: "createdBy", label: "Created By" },
    { value: "paymentTicketStatus", label: "Status" },
  ];

  const HandleView = (data) => {
    navigate(RoutesLink.stock_out_detail + `/${data?.id}`);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.create_stock_out, {
      state: { data: data, type: "Update" },
    });
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_stock_out + `?stockOutId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggleModal("delete");
        GetStockOutList();
      } else {
        toast.error(response?.message);
        toggleModal("delete");
      }
    });
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggleModal();
  };

  const ActionDataForPending = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
    ...(!(
      userDetails?.type === 2 ||
      userDetails?.designation?.name === "Coordinator"
    )
      ? [
        {
          label: "Edit",
          className: "btn btn-link",
          icon: <EditIcon />,
          title: "edit",
          clickHandler: HandleUpdate,
          isVisible: "pending",
          loggedInUserId: userDetails?.id,
        },
      ]
      : []),
    {
      label: "Delete",
      className: "btn btn-link",
      icon: <DeleteIcon />,
      title: "delete",
      isShow: false,
      isSiteEditable: false,
      isVisible: "pending",
      loggedInUserId: userDetails?.id,
      clickHandler: ActionHandler,
    },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
    ...(userDetails?.type === 1 && userDetails?.department?.name === "Account"
      ? [
        {
          label: "Edit",
          className: "btn btn-link",
          icon: <EditIcon />,
          title: "edit",
          isShow: "Finance Created",
          isSiteEditable: false,
          isVisible: false,
          clickHandler: HandleUpdate,
        },
      ]
      : []),
  ];

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      dispatch(updateFiltersStates({ currentPage: 1 }));
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 300);
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        pageSize: value,
        currentPage: 1,
      })
    );
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: "",
        })
      );
    }
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
            `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${
              searchQuery ? `&search=${searchQuery}` : ""
            }`
          : apiUrl.get_user_site +
            `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${
              searchQuery ? `&search=${searchQuery}` : ""
            }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
        ...prevState,
        ...(type === "site" && { siteId: data?.site }),
        ...(type === "companyId" && { companyId: data?.companyId }),
        ...(type == "companyId" && {
          siteId: "",
        }),
      }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
      })
    );
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const handleExport = () => {
    const filterData = {
      exportDataType: "stockOut",
      status: pageStates?.status,
      searchQuery: pageStates.searchQuery,
      ...filterDetails,
    }
    delete filterData?.currentPage;
    delete filterData?.pageSize;
    delete filterData?.count;
    delete filterData?.totalPages;
    ExportDataHandler(filterData);
  };

  const orderByHandler = (e) => {
  dispatch(
    updateFiltersStates({
      orderBy: e.target.value,
    })
  );
};

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Stock Out"}
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
          buttonLink={userDetails?.designation?.canCreate?.includes("stockOut") && RoutesLink?.create_stock_out}
          buttonText={userDetails?.designation?.canCreate?.includes("stockOut") && "Create Stock Out"}
        />
        <Nav tabs className="nav nav-tabs border-0 mb-4">
          <NavItem className="nav-item">
            <NavLink
              className={
                ActiveTab === "pending"
                  ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2 active"
                  : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("pending")}
            >
              Pending
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                ActiveTab === "approved"
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("approved")}
            >
              Approved
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                ActiveTab === "rejected"
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("rejected")}
            >
              Rejected
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={ActiveTab}>
          <TabPane tabId={"pending"}>
            <Fade in={ActiveTab === "pending"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    handleExport={pageStates?.StockList?.length > 0 ? handleExport : null}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                      getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingAgainstPo}
                    TableData={pageStates?.StockList}
                    ActionData={ActionDataForPending}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"approved"}>
            <Fade in={ActiveTab === "approved"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    handleExport={pageStates?.StockList?.length > 0 ? handleExport : null}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                      getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingAgainstPo}
                    TableData={pageStates?.StockList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"rejected"}>
            <Fade in={ActiveTab === "rejected"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    handleExport={pageStates?.StockList?.length > 0 ? handleExport : null}
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                      getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingAgainstPo}
                    TableData={pageStates?.StockList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
      <ConfirmModal
        modal={modal}
        toggle={() => toggleModal()}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
